import { render } from "./DashboardStateCard.vue?vue&type=template&id=274c176e&scoped=true"
import script from "./DashboardStateCard.vue?vue&type=script&lang=js"
export * from "./DashboardStateCard.vue?vue&type=script&lang=js"

import "./DashboardStateCard.vue?vue&type=style&index=0&id=274c176e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274c176e"]])

export default __exports__